import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_@babel+core@7.28.6_@opentelemetry+api@1.9.1_react-dom@19.2.3_react@19.2.3__react@19.2.3_sass@1.97.2/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["trackPageView","trackComponent","trackComponentLoad","firePageLoadEvent"] */ "/app/packages/analytics/src/analytics.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useAnalyticsAuthSync"] */ "/app/packages/analytics/src/hooks/useAnalyticsAuthSync.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/shared-ui/src/components/BFLApiFailure/BFLApiFailure.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/shared-ui/src/components/BFLLazyLoad/BFLLazyLoad.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/shared-ui/src/components/BFLLink/BFLLink.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/trading-mall/src/common/handlers/RedirectionHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/Banner/AnalyticsBannerLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/Banner/BannerCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/BudgetFriendlyETFs/BudgetETFMainClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/BudgetFriendlyETFs/BudgetETFsClinet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/ClosedIPO/ClosedIpoClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MostBroughtStocksClient"] */ "/app/packages/trading-mall/src/components/ClpStockCards/MostBroughtStocksClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/ClpStockCards/TopCategoriesClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/CurrentIPO/CurrentIPOClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/Demat/OpenDematFloatBannerCtaClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/Demat/OpenDematFloatBannerDesktopShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/Demat/OpenDematFloatBannerSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/Demat/OpenDematFloatBannerVisibilityClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/DescriptionWithColumns/DescriptionUtil.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/DisclaimerStrip/DisclaimerCloseButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/EasyAccess/SubComponet/EasyAccessLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/FAQ/FaqAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/FiiAndDiiTradingActivity/FiiAndDiiTradingActivity.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/trading-mall/src/components/HideOnLogin/HideOnLogin.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/Ipo/IpoClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/IpoList/IpoListWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/IpoTitleWithDescription/IpoDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/LatestFinancialResult/LatestFinancialResultClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/LatestFinancialResult/LatestFinancialResultClientMain.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DaysRangeSlider"] */ "/app/packages/trading-mall/src/components/MarketIndicesDashboard/DaysRangeSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IndexValueDisplay"] */ "/app/packages/trading-mall/src/components/MarketIndicesDashboard/IndexValueDisplay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IndicesActions"] */ "/app/packages/trading-mall/src/components/MarketIndicesDashboard/IndicesActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IndicesHeader"] */ "/app/packages/trading-mall/src/components/MarketIndicesDashboard/IndicesHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IndicesTabs"] */ "/app/packages/trading-mall/src/components/MarketIndicesDashboard/IndicesTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/MarketIndicesDashboard/MarketIndicesClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OpenInterestDisplay"] */ "/app/packages/trading-mall/src/components/MarketIndicesDashboard/OpenInterestDisplay.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/trading-mall/src/components/MarketInsigtsHeading/conditionalSubtext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/MarketToday/MarketToday.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["STOCK_LISTING_PAGINATION_BUTTON_CLASS"] */ "/app/packages/trading-mall/src/components/News/components/List.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrendingNewsError","default"] */ "/app/packages/trading-mall/src/components/News/components/TrendingNewsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/News/StockNewsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PayLaterMtfClient"] */ "/app/packages/trading-mall/src/components/PayLaterMtfs/PayLaterMtfClinet.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/trading-mall/src/components/Portfolio/PortfolioContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/PreMarketInsights/PreMarketInsightsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/ServiceSection/ServiceSectionCtCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/StockListingTable/StockListingTableAEM.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/TradingSection/TradingSectionClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/UpcomingIpo/UpcomingIpoTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/components/VideoCarousel/VideoCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/pages/GlobalIndices/StockListWithTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/pages/StockListingPage/components/StockHeaderBarMobileControls.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/pages/StockListingPage/components/StockHeaderBarMobileDynamicContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/pages/StockListingPage/components/StockListingError.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/pages/StockListingPage/components/StockSortDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/pages/StockListingPage/components/StockTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/pages/StockListingPage/StockListingPageClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/pages/TrendingStocksPlp/components/TrendingStocksInfoBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/pages/TrendingStocksPlp/TrendingStocksCarouselClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/trading-mall/src/pages/TrendingStocksPlp/TrendingStocksPlpInteractiveClient.tsx");
